import subscribeSaga from './subscribeSaga';
import consumerReducer from './reducer';
import { reduxModuleLoaded } from './actions';
import { tierConsumerReduxKey } from './constants';
export function getModule() {
    return {
        id: 'tierConsumer',
        reducerMap: {
            [tierConsumerReduxKey]: consumerReducer
        },
        sagas: [
            subscribeSaga
        ],
        initialActions: [
            reduxModuleLoaded()
        ],
        retained: true
    };
}
